export const BASEAPIURL = "http://localhost:36012/";
